import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth.module'
import breadcrumbs from './breadcrumbs.module'
import config from './config.module'
import countries from './countries.module'
import groups from './groups.module'
import firewalls from './firewalls.module'
import htmlClass from './htmlclass.module'
import integrations from './integrations.module'
import macroses from './macroses.module'
import notifications from './notifications.module'
import profile from './profile.module'
import recipes from './recipes.module'
import recipesGroups from './recipes-groups.module'
import resellers from './resellers.module'
import reseller_api from './reseller_api.module'
import reseller_revenuecat from './reseller_revenuecat.module'
import reseller_webhook from './reseller_webhook.module'
import servers from './servers.module'
import tariffs from './tariffs.module'
import users from './users.module'
import vpnServers from './vpn-servers.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    breadcrumbs,
    config,
    countries,
    groups,
    firewalls,
    htmlClass,
    integrations,
    macroses,
    notifications,
    profile,
    recipes,
    recipesGroups,
    resellers,
    reseller_api,
    reseller_revenuecat,
    reseller_webhook,
    servers,
    tariffs,
    users,
    vpnServers,
  },
})
